import { RichTextEditor } from '@talentmesh/rte';
import React from 'react';

interface EmailTemplateViewerProps extends React.HTMLAttributes<HTMLDivElement> {
    htmlTemplate: string;
}

function EmailTemplateViewer({ htmlTemplate, className }: EmailTemplateViewerProps): React.JSX.Element {
    return (
        <RichTextEditor
            editable={false}
            features={['bold', 'italic', 'underline', 'ol', 'ul']}
            initialHtml={htmlTemplate}
            toolbarProps={{ className: 'hidden' }}
            contentEditableProps={{
                ariaLabel: 'view email template',
                className,
            }}
        />
    );
}

export default EmailTemplateViewer;
